'use client';

/**
 * Имя продукта, на домене которого открыта страница.
 *
 * Нужно страницам входа, регистрации и восстановления: они общие для всей
 * платформы, а вот подписаны должны быть тем продуктом, откуда человек
 * пришёл. Иначе, нажав «Войти» на DataHunter, он видит над формой чужое
 * имя и не понимает, туда ли попал.
 *
 * Значение приходит с сервера, где известен хост запроса. Определять его
 * на клиенте по `window.location` нельзя: до гидратации имени нет, и
 * заголовок формы менялся бы на глазах.
 */

import { createContext, useContext, type ReactNode } from 'react';

const BrandContext = createContext('INGDG');

export function BrandProvider({ name, children }: { name: string; children: ReactNode }) {
  return <BrandContext.Provider value={name}>{children}</BrandContext.Provider>;
}

/** Имя продукта текущего домена. */
export function useBrandName(): string {
  return useContext(BrandContext);
}
